'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _feedStore = require('../../../store/feed-store');

var _propTypes = require('../../../shared/prop-types');

var _connectedAddReaction = require('./connected-add-reaction');

var _connectedAddReaction2 = _interopRequireDefault(_connectedAddReaction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddReaction = function (_PureComponent) {
  _inherits(AddReaction, _PureComponent);

  function AddReaction(props, context) {
    _classCallCheck(this, AddReaction);

    var _this = _possibleConstructorReturn(this, (AddReaction.__proto__ || Object.getPrototypeOf(AddReaction)).call(this, props));

    _this.state = {
      store: props.store || context.store || (0, _feedStore.createFeedStore)()
    };
    return _this;
  }

  _createClass(AddReaction, [{
    key: 'render',
    value: function render() {
      // Do not pass store in as prop or connect() will use that over the store Provider puts on the context.
      var propsWithoutStore = _extends({}, this.props, { store: null });
      delete propsWithoutStore.store;

      // Use the store from state as Provider doesn't support hotswapping stores
      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: this.state.store },
        _react2.default.createElement(_connectedAddReaction2.default, propsWithoutStore)
      );
    }
  }]);

  return AddReaction;
}(_react.PureComponent);

AddReaction.propTypes = {
  communityContentIdObject: _propTypes.CommunityContentId,
  isBlock: _react.PropTypes.bool,
  label: _react.PropTypes.string,
  size: _react.PropTypes.string,
  store: _propTypes.StoreShape,
  logData: _react.PropTypes.object
};
AddReaction.defaultProps = {
  logData: {}
};
AddReaction.contextTypes = {
  store: _propTypes.StoreShape
};
exports.default = AddReaction;